import React from 'react';

function SubNavbar() {
  return (
    
    <nav className="sub-navbar pt-4 py-3">
      <div className="container">
        <ul className="sub-navbar-nav">
          <li>
            <a href="https://linternadepapel.cl" target="_blank" rel="noopener noreferrer">
        
              
            </a>
          </li>
          <li>
            <a href="https://resistenciainformativa.org" target="_blank" rel="noopener noreferrer">
              
              
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default SubNavbar;